'use client';

import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string | string[];
}

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: "1. Warum gibt es FINVION Profit Expander?",
      answer: "Die meisten Amazon-Tools optimieren für ACOS und ROAS. FINVION wurde geschaffen, weil Verkäufer etwas anderes brauchten: echte Gewinnklarheit auf Keyword-Ebene, bevor sie ein Gebot anfassen. Gewinn ist die eine Kennzahl, die jedem Verkäufer wichtig ist, doch kein Mainstream-Tool rekonstruiert den echten Gewinn pro Keyword durch Kombination von Ads-API-Daten, SP-API-Bestellungen, FBA-Gebühren, Rückerstattungen und Ihren Selbstkosten. FINVION wurde entwickelt, um diese Lücke zu schließen und Verkäufern die finanzielle Wahrheit zu geben, die ihre Werbetools nicht berechnen."
    },
    {
      question: "2. Was macht FINVION anders als bestehende PPC-Tools?",
      answer: [
        "Andere Tools konzentrieren sich auf Automatisierung oder Massenregeln. FINVION konzentriert sich auf Gewinnsichtbarkeit + sichere manuelle Entscheidungen.",
        "Hauptunterschiede:",
        "• rekonstruiert tatsächlichen Gewinn auf Keyword-Ebene, einschließlich Rückerstattungen und Kostensteigerungen",
        "• berechnet CPC-Sicherheitsgrenzen basierend auf Ihren echten Margen",
        "• bietet konservative manuelle Gebotsempfehlungen",
        "• verwendet strenge Sicherheitsschranken statt Automatisierung",
        "• keine Kampagnenumstrukturierung, kein KI-\"Raten\", kein Risiko für Rankings",
        "",
        "FINVION unterstützt Ihre Entscheidungen, ohne Ihr Konto zu übernehmen."
      ]
    },
    {
      question: "3. Was ist der Hauptunterschied zwischen manueller Gewinnberechnung und FINVIONs Profit Expander Methode?",
      answer: "Manuelle Gewinnverfolgung ist langsam, fehleranfällig und meist unvollständig. Die meisten Tabellen kombinieren nur wenige Variablen wie Ausgaben, Verkäufe und ACOS. Sie berücksichtigen selten Rückerstattungsbelastungen, Kostensteigerungen, echte Selbstkosten oder Keyword-Zuordnung. Dies führt zu Entscheidungen auf Basis unvollständiger Daten. FINVION verwendet ein einheitliches Gewinnrekonstruktionsmodell, das Ads-API-Performance, SP-API-Bestellungen, FBA-Gebühren, Empfehlungsgebühren, Rückerstattungen und Ihre exakten Selbstkosten zusammenführt. Das Ergebnis ist eine präzise tägliche Gewinnberechnung für jedes Keyword. Wo Tabellen Annäherungen zeigen, zeigt FINVION die volle finanzielle Wahrheit hinter jeder Gebotsentscheidung."
    },
    {
      question: "4. Warum liefert FINVION bessere Ergebnisse als Tabellen, manuelle Vergleiche oder allgemeine PPC-Tools?",
      answer: [
        "FINVION eliminiert Rätselraten. Statt zwischen Dashboards zu wechseln, Margen manuell zu berechnen oder sich auf reine ACOS-Tools zu verlassen, zeigt FINVION:",
        "• echten Gewinn pro Keyword",
        "• CPC-Sicherheitsgrenzen basierend auf tatsächlichen Margen",
        "• Rückerstattungsbelastung und Kostensteigerungen",
        "• stabile, konservative Gebotsvorschläge",
        "",
        "Die meisten PPC-Tools optimieren für ACOS, ROAS oder Klickeffizienz. FINVION optimiert für echte finanzielle Ergebnisse. Die meisten Tabellen hängen von manuellen Aktualisierungen ab. FINVION aktualisiert täglich automatisch.",
        "",
        "Diese Kombination aus Genauigkeit, Vollständigkeit und sicherer Gebotslogik führt zu konsistenteren Margenschutz und schnellerer Verschwendungsreduzierung im Vergleich zu manuellen Workflows oder generischen Optimierungsplattformen."
      ]
    },
    {
      question: "5. Kann ich FINVION zusammen mit Teikametrics, Perpetua, Eva.guru usw. verwenden?",
      answer: [
        "Ja. FINVION ist speziell dafür entwickelt, parallel zu jedem automatisierten Tool zu laufen.",
        "",
        "Es macht nicht:",
        "• Gebote automatisch ändern",
        "• Regeln überschreiben",
        "• Anzeigengruppen umstrukturieren",
        "• externe Kampagnen einschleusen",
        "",
        "Es gibt Ihnen einfach echte Gewinnsignale und sichere Gebotsvorschläge, die Sie manuell anwenden. Dies macht FINVION zur perfekten \"Gewinnwahrheitsschicht\" über jeder Automatisierung, die Sie bereits verwenden."
      ]
    },
    {
      question: "6. Kann FINVION berechnen, wie viel Zeit ich im Vergleich zur manuellen Analyse spare?",
      answer: [
        "Ja. FINVION ersetzt Dutzende manuelle Schritte, die Werbetreibende typischerweise jede Woche Stunden kosten. Manuelle Workflows erfordern das Herunterladen von Berichten, Zusammenführen von Tabellen, Berechnen von Margen, Verfolgen von CPC-Drift, Überprüfen von Rückerstattungen, Vergleichen von Trends und Bewerten jedes Keywords.",
        "",
        "FINVION automatisiert die gesamte Bewertungsebene durch:",
        "• Rekonstruktion des echten Gewinns pro Keyword täglich",
        "• Kombination von Ads-API + SP-API + Gebühren + Rückerstattungen + Selbstkosten",
        "• Erkennung von CPC-Drift und Margenerosion",
        "• automatische Identifizierung von Gewinnlecks",
        "• sofortige Generierung sicherer Gebotsempfehlungen",
        "",
        "Statt Stunden mit Sammeln und Berechnen von Daten zu verbringen, überprüfen Werbetreibende nur die Ausgabe und wenden Empfehlungen an. Die meisten Nutzer reduzieren die wöchentliche PPC-Analysezeit um 60 bis 85 Prozent, abhängig von der Kontogröße."
      ]
    },
    {
      question: "7. Liefert FINVION noch Ergebnisse, wenn ich überhaupt keine Automatisierung verwende?",
      answer: "Ja. FINVION funktioniert am besten mit manueller Kontrolle, weil Sie die Anpassungen selbst vornehmen. Die Empfehlungen des Tools sind absichtlich konservativ, gewinnorientiert und einfach umzusetzen. Die meisten Nutzer sehen reduzierte verschwendete Ausgaben und gesündere Margen innerhalb der ersten 7-21 Tage, selbst mit rein manuellen Workflows."
    },
    {
      question: "8. Schadet die Verwendung von FINVION meinem Amazon-Ranking?",
      answer: [
        "Nein. Die Empfehlungs-Engine von FINVION ist auf Ranking-Sicherheit ausgelegt. Jeder Vorschlag ist begrenzt durch:",
        "• max. +12 Prozent Erhöhung",
        "• max. –20 Prozent Senkung",
        "• HALTEN wenn Daten instabil sind",
        "• keine Empfehlungen bei volatilen Keywords",
        "",
        "Es gibt kein aggressives Bieten oder algorithmisches Experimentieren. FINVION schützt Rankings, anstatt sie zu riskieren."
      ]
    },
    {
      question: "9. Erfordert FINVION lange Einrichtung oder historische Daten?",
      answer: "Nein. Sobald Ihre Ads-API- und SP-API-Berechtigungen verbunden sind, liefert FINVION aussagekräftige Einblicke innerhalb von 24-48 Stunden. Es gibt keine Aufwärmphase, keine Trainingsphase und keinen Algorithmus-Anlauf."
    },
    {
      question: "10. Welche Art von Verkäufern oder Agenturen profitieren am meisten von FINVION?",
      answer: [
        "FINVION ist ideal für:",
        "• Verkäufer mit 3.000–100.000+ Euro Ausgaben pro Monat",
        "• Agenturen, die mehrere Konten verwalten",
        "• Marken, die manuelle Kontrolle bevorzugen",
        "• Werbetreibende, die Gewinnklarheit statt ACOS-Raten wollen",
        "",
        "Wenn Gewinnschutz Priorität hat, liefert FINVION sofortigen Wert."
      ]
    },
    {
      question: "11. Welche Daten verwendet FINVION zur Berechnung des echten Gewinns?",
      answer: [
        "FINVION führt Daten zusammen aus:",
        "• Amazon Ads-API",
        "• Amazon SP-API-Bestellungen",
        "• FBA-Gebühren",
        "• Empfehlungsgebühren",
        "• Rückerstattungen und Rücksendekosten",
        "• Ihren Selbstkosten-Eingaben",
        "",
        "Dies erzeugt ein echtes tägliches Gewinnmodell für jedes Keyword, ASIN und jede Kampagne."
      ]
    },
    {
      question: "12. Was bedeutet \"manuelle Gebotsempfehlung\" eigentlich?",
      answer: [
        "FINVION gibt Ihnen sichere, konservative Anpassungen basierend auf Gewinnlogik. Sie wenden sie in Amazon Ads mit einem Klick an. Dies gewährleistet:",
        "• volle Benutzerkontrolle",
        "• kein Automatisierungsrisiko",
        "• keine plötzlichen Gebotsschocks",
        "• Ranking-Stabilität",
        "",
        "FINVION agiert wie ein finanzieller Co-Pilot, nicht als Ersatz Ihrer Prozesse."
      ]
    },
    {
      question: "13. Wie berechnet FINVION Gebotsempfehlungen auf eine Weise, die ein Mensch nicht zuverlässig kann?",
      answer: [
        "FINVION kombiniert Datenpunkte, die ein Mensch auf Keyword-Ebene nicht konsistent verfolgen oder aktualisieren kann. Jede Empfehlung basiert auf einem proprietären Gewinnrekonstruktionsmodell, das zusammenführt:",
        "",
        "• Amazon Ads-API-Performance",
        "• SP-API-Bestellungen und Verkaufszuordnung",
        "• FBA-Gebühren",
        "• Empfehlungsgebühren",
        "• Rückerstattungsauswirkung",
        "• Kostensteigerung",
        "• Ihre exakten Selbstkosten",
        "• Keyword-Intent-Klassifizierung",
        "• semantische Keyword-Relevanz",
        "• CPC-Drift-Muster",
        "• Margenschwellen",
        "",
        "FINVION berechnet all diese Elemente täglich neu und wandelt sie in eine CPC-Sicherheitsgrenze, eine Gewinnspanne und ein sicheres Anpassungsfenster um. Dies ermöglicht es dem System, das maximale Gebot zu schätzen, das noch die Marge schützt, das minimale Gebot, das den Traffic-Fluss aufrechterhält, und ob ein Keyword gehalten, erhöht oder reduziert werden sollte.",
        "",
        "Ein Mensch kann dies manuell versuchen, aber es ist extrem schwierig, weil:",
        "• die Anzahl der Variablen sich täglich ändert",
        "• Rückerstattungs- und Gebührenauswirkungen hinter Werbedaten zurückbleiben",
        "• CPC-Drift ohne Modellierung unsichtbar ist",
        "• Relevanzverschiebungen ohne semantische Prüfungen nicht offensichtlich sind",
        "• Margenerosion oft langsam geschieht und leicht übersehen wird",
        "• Tabellen nicht zuverlässig auf Keyword-Ebene aktualisieren können",
        "",
        "FINVION bewertet diese Signale gleichzeitig, identifiziert versteckte Gewinnlecks und übersetzt sie in konservative, ranking-sichere manuelle Gebotsvorschläge. Das Ergebnis ist ein Genauigkeits- und Konsistenzniveau, das mit Tabellen oder manuellen Überprüfungen nahezu unmöglich zu erreichen ist."
      ]
    },
    {
      question: "14. Wann werden automatisiertes Bieten oder Ranking-Tracking hinzugefügt?",
      answer: [
        "Diese Funktionen kommen in späteren Versionen:",
        "• automatisiertes Bieten → nicht Teil von MVP 0.5",
        "• Sichtbarkeits- und Ranking-Tracking → MVP 0.9",
        "• Preisoptimierung & LaunchDrive → spätere Meilensteine"
      ]
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const renderAnswer = (answer: string | string[]) => {
    if (typeof answer === 'string') {
      return <p data-component-id="src/app/landing-page-de/components/FAQSection.tsx:184:13" data-component-path="src/app/landing-page-de/components/FAQSection.tsx" data-component-line="184" data-component-file="FAQSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B16px%5D%20md%3Atext-%5B18px%5D%20text-%5B%232f3640%5D%20leading-%5B140%25%5D%22%7D" className="text-[16px] md:text-[18px] text-[#2f3640] leading-[140%]">{answer}</p>;
    }
    
    return (
      <div data-component-id="src/app/landing-page-de/components/FAQSection.tsx:188:6" data-component-path="src/app/landing-page-de/components/FAQSection.tsx" data-component-line="188" data-component-file="FAQSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-%5B16px%5D%20md%3Atext-%5B18px%5D%20text-%5B%232f3640%5D%20leading-%5B140%25%5D%20space-y-3%22%7D" className="text-[16px] md:text-[18px] text-[#2f3640] leading-[140%] space-y-3">
        {answer.map((line, idx) => (
          <p data-component-id="src/app/landing-page-de/components/FAQSection.tsx:190:10" data-component-path="src/app/landing-page-de/components/FAQSection.tsx" data-component-line="190" data-component-file="FAQSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%7D" key={idx}>{line}</p>
        ))}
      </div>
    );
  };

  return (
    <section data-component-id="src/app/landing-page-de/components/FAQSection.tsx:197:4" data-component-path="src/app/landing-page-de/components/FAQSection.tsx" data-component-line="197" data-component-file="FAQSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22faq%22%2C%22className%22%3A%22py-24%20md%3Apy-32%20bg-white%20px-4%20md%3Apx-16%22%7D" id="faq" className="py-24 md:py-32 bg-white px-4 md:px-16">
      <div data-component-id="src/app/landing-page-de/components/FAQSection.tsx:198:6" data-component-path="src/app/landing-page-de/components/FAQSection.tsx" data-component-line="198" data-component-file="FAQSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1200px%5D%20mx-auto%22%7D" className="max-w-[1200px] mx-auto">
        <h2 data-component-id="src/app/landing-page-de/components/FAQSection.tsx:199:8" data-component-path="src/app/landing-page-de/components/FAQSection.tsx" data-component-line="199" data-component-file="FAQSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B32px%5D%20md%3Atext-%5B40px%5D%20font-bold%20text-%5B%234cd137%5D%20mb-12%20text-center%22%2C%22textContent%22%3A%22Q%26A%22%7D" className="text-[32px] md:text-[40px] font-bold text-[#4cd137] mb-12 text-center">
          Q&A
        </h2>

        <div data-component-id="src/app/landing-page-de/components/FAQSection.tsx:203:8" data-component-path="src/app/landing-page-de/components/FAQSection.tsx" data-component-line="203" data-component-file="FAQSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-4%20max-w-4xl%20mx-auto%22%7D" className="space-y-4 max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <div data-component-id="src/app/landing-page-de/components/FAQSection.tsx:205:12" data-component-path="src/app/landing-page-de/components/FAQSection.tsx" data-component-line="205" data-component-file="FAQSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-%5B%23f5f6fa%5D%20rounded-lg%20overflow-hidden%20border-2%20border-%5B%23dcdde1%5D%20hover%3Aborder-%5B%234cd137%5D%20transition-colors%22%7D"
              key={index}
              className="bg-[#f5f6fa] rounded-lg overflow-hidden border-2 border-[#dcdde1] hover:border-[#4cd137] transition-colors"
            >
              <button data-component-id="src/app/landing-page-de/components/FAQSection.tsx:209:14" data-component-path="src/app/landing-page-de/components/FAQSection.tsx" data-component-line="209" data-component-file="FAQSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22w-full%20text-left%20px-6%20py-5%20flex%20items-center%20justify-between%22%7D"
                onClick={() => toggleFAQ(index)}
                className="w-full text-left px-6 py-5 flex items-center justify-between"
              >
                <span data-component-id="src/app/landing-page-de/components/FAQSection.tsx:213:16" data-component-path="src/app/landing-page-de/components/FAQSection.tsx" data-component-line="213" data-component-file="FAQSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-%5B16px%5D%20md%3Atext-%5B18px%5D%20font-semibold%20text-%5B%232f3640%5D%20pr-4%22%7D" className="text-[16px] md:text-[18px] font-semibold text-[#2f3640] pr-4">
                  {faq.question}
                </span>
                <span data-component-id="src/app/landing-page-de/components/FAQSection.tsx:216:16" data-component-path="src/app/landing-page-de/components/FAQSection.tsx" data-component-line="216" data-component-file="FAQSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-%5B24px%5D%20text-%5B%234cd137%5D%20flex-shrink-0%22%7D" className="text-[24px] text-[#4cd137] flex-shrink-0">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              
              {openIndex === index && (
                <div data-component-id="src/app/landing-page-de/components/FAQSection.tsx:222:16" data-component-path="src/app/landing-page-de/components/FAQSection.tsx" data-component-line="222" data-component-file="FAQSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22px-6%20pb-5%22%7D" className="px-6 pb-5">
                  {renderAnswer(faq.answer)}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;